// src/utils/storage.js
export function saveProfile(p = {}) {
  if (p.height != null) localStorage.setItem('userHeight', String(p.height));
  if (p.weight != null) localStorage.setItem('userWeight', String(p.weight));
  if (p.age != null)    localStorage.setItem('userAge', String(p.age));
  if (p.gender)         localStorage.setItem('userGender', p.gender);
  if (p.zodiac)         localStorage.setItem('zodiac', p.zodiac);   // <-- IMPORTANT

  // let listeners (Home, Dashboard) refresh
  window.dispatchEvent(new Event('profile-updated'));
}

export function addHistory(entry) {
  const key = 'history';
  const list = JSON.parse(localStorage.getItem(key) || '[]');
  list.unshift(entry);
  localStorage.setItem(key, JSON.stringify(list.slice(0, 50)));
  window.dispatchEvent(new Event('profile-updated'));
}